import { itemClicked } from '../analyticsHelpers';

export default {
  elements: {
    // Header - Unauth and Auth
    'header--logo': itemClicked('Header', 'Logo'),
    // Unauth Header
    'unauth-[header,side-bar]*': itemClicked('Unauth Header'),
    // Auth Header
    'auth-[header,side-bar]*': itemClicked('Auth Header'),
  },
};



// WEBPACK FOOTER //
// ./src/app/browser/header/headerAnalytics.js